import { Link } from 'react-router-dom';

const ProjectsSection = () => {
  return (
    <section className="py-16 md:py-24 bg-cream">
      <div className="container mx-auto px-6">
        {/* Header */}
        <div className="mb-12 md:mb-16 text-center">
          <span className="text-wood text-xs md:text-sm font-medium tracking-wider uppercase">/ Referanslarımız</span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-wood-dark mt-4 mb-6 leading-tight">
            Tamamlanan Projeler
          </h2>
          <p className="text-sm md:text-lg text-wood max-w-2xl mx-auto">
            İzmir genelinde gerçekleştirdiğimiz başarılı tadilat ve dekorasyon projelerimizden örnekler
          </p>
        </div>

        {/* CTA */}
        <div className="text-center">
          <Link
            to="/referanslar"
            className="inline-flex items-center space-x-2 px-6 md:px-8 py-3 md:py-4 bg-wood hover:bg-wood-dark text-white rounded-full font-medium transition-all duration-300 whitespace-nowrap cursor-pointer text-sm md:text-base"
          >
            <span>Tüm Projeleri İncele</span>
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ProjectsSection;
